import React from 'react';
import Dialog from '@material-ui/core/Dialog';
export default function LinearIndeterminate() { 
  return (
        <Dialog open={true} />            
      
  );
}